import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { DatadogService } from '../../service';

export type ActivePipelinesConfig = typeof ActivePipelinesConfig._.Config;

export const ActivePipelinesConfig = IntegrationConfig.make({
  service: DatadogService,
  name: Integration_Handler_Names_Enum.ActivePipelines,
  configSchema: z.object({
    pipelineIds: z.array(z.string().min(1)).min(1),
  }),
});
